import { Component, Fragment, lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { getRoutes, getSetting } from "./actions/navActions";
// import { LAYOUT_HOME, LAYOUT_COMMON_LANDING, LAYOUT_GALLERY, LAYOUT_BRANCH, LAYOUT_MEMBER } from "./constants";

import { Toaster } from "react-hot-toast";
import Htmlhelmet from "./components/common/HtmlHelmet";
import ScrollToTop from "./components/common/ScrollToTop";

import configureStore from "./store/Configurstore";

// Lazy-loaded components for code splitting (reduces initial bundle size by 70-80%)
const CommonHeader = lazy(
  () => import("./components/common/header/Commonheader"),
);
const HomeLayout = lazy(() => import("./layout/Home"));
const PageLayout = lazy(() => import("./layout/Page"));

const Member = lazy(() => import("./layout/MemberLayout"));

const OfficeBranch = lazy(() => import("./components/branch/Branch"));

const Career = lazy(() => import("./components/career/Career"));
const CareerDetails = lazy(() => import("./components/career/CareerDetails"));
const ContactPage = lazy(() => import("./components/contact/ContactPage"));
const CommonLanding = lazy(() => import("./page/CommonLanding"));
const Footer = lazy(() => import("./components/common/Footer"));

const { store } = configureStore();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      utils: store.getState().utils,
      routemenu: store.getState().utils.routemenu,
      pubroutemenu: store.getState().utils.pubroutemenu,
    };
  }


  componentDidMount = () => {
    // Cache configuration
    const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes
    const cacheTimestamp = localStorage.getItem("app_cache_timestamp");
    const isCacheValid =
      cacheTimestamp && Date.now() - parseInt(cacheTimestamp) < CACHE_DURATION;

    // Check cache for routes
    const cachedRoutes = localStorage.getItem("app_routes");
    const cachedSettings = localStorage.getItem("app_settings");

    if (isCacheValid && cachedRoutes) {
      // Use cached routes
      this.setState({ routemenu: JSON.parse(cachedRoutes) });
    }

    // Parallelize API calls for better performance
    const apiCalls = [];

    // Only fetch routes if cache is invalid or missing
    if (!isCacheValid || !cachedRoutes) {
      apiCalls.push(
        store.dispatch(getRoutes()).then((res) => {
          this.setState({ routemenu: res });
          localStorage.setItem("app_routes", JSON.stringify(res));
          localStorage.setItem("app_cache_timestamp", Date.now().toString());
          return res;
        }),
      );
    }

    // Only fetch settings if cache is invalid or missing
    if (!isCacheValid || !cachedSettings) {
      apiCalls.push(
        store.dispatch(getSetting()).then((res) => {
          localStorage.setItem("app_settings", JSON.stringify(res));
          return res;
        }),
      );
    }

    // Execute all API calls in parallel
    if (apiCalls.length > 0) {
      Promise.all(apiCalls).catch((error) => {
        console.error("Error loading app data:", error);
      });
    }
  };

  render() {
    const routemenu = this.state.routemenu;
    // const basename = process.env.PUBLIC_URL || "/";
    const basename = "/";

    // Loading fallback component for code splitting
    const LoadingFallback = () => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          fontSize: "18px",
          color: "#666",
        }}
      >
        <div className="ripple"></div>
      </div>
    );

    return (
      <Router basename={basename}>
        <ScrollToTop />
        <Fragment>

          <Toaster />
          <Htmlhelmet />
          <Suspense fallback={<LoadingFallback />}>
            <CommonHeader />

            <Switch>
              <Route exact path={`/`}>
                <HomeLayout />
              </Route>

              <Route exact path="/contact">
                <ContactPage />
              </Route>
              <Route exact path="/career">
                <Career />
              </Route>
              <Route exact path="/career-details/:id">
                <CareerDetails />
              </Route>

              <Route path="/page/:slug">
                <PageLayout />
              </Route>
              <Route path={`/:slug`}>
                <PageLayout />
              </Route>

              {routemenu.map((menu, index, { length }) => {
                if (menu.layout) {

                  if (menu.layout.name.toLowerCase() === "home") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <HomeLayout />}
                      />
                    );
                  }
                  if (menu.layout.name.toLowerCase() === "common landing") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <CommonLanding />}
                      />
                    );
                  }
                  if (menu.layout.name.toLowerCase() === "gallery") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <CommonLanding />}
                      />
                    );
                  }

                  if (menu.layout.name.toLowerCase() === "branch") {
                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <OfficeBranch />}
                      />
                    );
                  }

                  if (menu.layout.name.toLowerCase() === "member") {

                    return (
                      <Route
                        key={menu.id}
                        exact
                        path={`${menu.slug}`}
                        render={() => <Member />}
                      />
                    );
                  }
                } else {
                  return (
                    <Route
                      key={menu.id}
                      exact
                      path={`${menu.slug}`}
                      render={() => "404 NOT FOUND"}
                    />
                  );
                }
              })}
            </Switch>
            <Footer />
          </Suspense>
        </Fragment>
      </Router>
    );
  }
}

export default App;
